export function getPrompt(value) {
  return value === 'responsiblePersonContactDetails'
    ? 'What is the email of the responsible person?'
    : "What is the patient's email address?"
}
